// SubcatchmentPatternsDialog.js
import { useState, useEffect } from "react"
import { Typography, Button } from '@mui/material'
import SubcatchmentPatternsForm from './SubcatchmentPatternsForm'
import "../../css/DemoCode.css"

/**
 * Frame for data inputs. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} targetType The name of the SWMM inp section targetted by this form.
 * @param {string} target The name of the object targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function SubcatchmentPatternsDialog({ model, setModel, targetType, target }) {
  const [submodel, setSubmodel] = useState()
  
  // Create a submodel for this editor interface.
  useEffect(()=>{
    // Create a group of empty coverages for each type of landuse
    if(!model.ADJUSTMENTS.PATTERN) model.ADJUSTMENTS.PATTERN={}
    let modelPATTERN = model.ADJUSTMENTS.PATTERN[target]?model.ADJUSTMENTS.PATTERN[target]:{}
    let PATTERN = {[target]:{
      "DSTORE": "",
      "INFIL" : "",
      "N-PERV": "",
      ...modelPATTERN
    }}

    setSubmodel({
      PATTERN: PATTERN
    })
  }, [])

  const saveEdits = () => {
    let cleanSub = JSON.parse(JSON.stringify(submodel))
    setModel(prev => ({
      ...prev,
      ADJUSTMENTS:{
        ...prev.ADJUSTMENTS, 
        PATTERN: {
          ...prev.ADJUSTMENTS.PATTERN,
          [target]: {
            ...cleanSub.PATTERN[target]
          }
        }
      }
    }))
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  if(submodel){
    return(
    <>
      <Typography id="modal-modal-title" variant="p4" >
        <div style={{display:"flex", flexDirection: "column", padding: '10px'}}>
          <label>Patterns for Subcatchment {target}</label>
        </div>
      </Typography>
      <div>
        <Button fullWidth onClick={saveEdits} >Save Edits</Button>
      </div>
      <div style={{height: "280px", background:'black', overflowY: 'scroll', paddingBottom:"120px"}}>
        {
          targetType && 
          targetType in model && 
          target &&
          <SubcatchmentPatternsForm model={submodel} setModel={setSubmodel} fullModel={model} target={target} />
        }
      </div>
    </>
    )
  } else {
    return null;
  }
}